// src/firebase/firebase.js
import { CapacitorHttp } from "@capacitor/core";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCNSd_Oe15e__CaaFw0HRfhPBMK7wwH7jY",
  authDomain: "gigitherobot-4550d.firebaseapp.com",
  projectId: "gigitherobot-4550d",
  storageBucket: "gigitherobot-4550d.appspot.com",
  messagingSenderId: "793326703244",
  appId: "1:793326703244:web:ba083450d95c2bf09ee1a9",
  measurementId: "G-46MHHF0N14"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// ✅ Hàm detect xem có CapacitorHttp không
const isCapacitor = () => !!window.Capacitor;

export const signIn = async (email, password) => {
  if (isCapacitor()) {
    // 👉 Dùng CapacitorHttp nếu đang chạy trong app
    const response = await CapacitorHttp.post({
      url: `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${firebaseConfig.apiKey}`,
      headers: { "Content-Type": "application/json" },
      data: {
        email,
        password,
        returnSecureToken: true,
      }
    });

    if (response.data && response.data.idToken) {
      return response.data;  // Success
    } else {
      throw new Error(response.data.error?.message || "Unknown login error");
    }
  } else {
    // 👉 Dùng firebase SDK khi chạy WebApp
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  }
};

export const signUp = async (email, password) => {
  if (isCapacitor()) {
    // 👉 CapacitorHttp đăng ký
    const response = await CapacitorHttp.post({
      url: `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${firebaseConfig.apiKey}`,
      headers: { "Content-Type": "application/json" },
      data: {
        email,
        password,
        returnSecureToken: true,
      }
    });

    if (response.data && response.data.idToken) {
      return response.data;  // Success
    } else {
      throw new Error(response.data.error?.message || "Unknown signup error");
    }
  } else {
    // 👉 firebase SDK đăng ký
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  }
};